import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-assigned-staff',
  templateUrl: './assigned-staff.component.html',
  styleUrls: ['./assigned-staff.component.scss']
})
export class AssignedStaffComponent implements OnInit {

  @Input() staffInfo: any;
  constructor() { }

  ngOnInit(): void {}

  formatPhone(phoneCode: string, phoneNumber: string): string {
    if (!phoneNumber) return '';
    const cleaned = phoneNumber.replace(/\D/g, '');
    if (phoneCode) {
      const num = cleaned
        .slice(0, 10)
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1)$2-$3');
      return `(${phoneCode})${num}`;
    }
    if (cleaned.length >= 10) {
      return cleaned
        .slice(0, 10)
        .replace(/(\d{3})(\d{3})(\d{4})/, '($1)$2-$3');
    }
    return phoneNumber;
  }

}
